<template>
    <div>
        <p class="qs-500 message-body" :class="[ { '': mine }, { 'tw-text-black': !mine }, ]" v-html="body" ></p>
        <div class="images tw-max-w-xs tw-mb-2">
            <lightbox :images="message.attachments" thumbnailSrc="url" src="url" customImageClass="message-attachment"></lightbox>
        </div>
    </div>
</template>

<script>
import LightBox from '../../shared/LightBox.vue';

export default {
	name: 'MessageImage',
	props: ['mine', 'message', 'body'],
	components: { 'lightbox': LightBox }
};
</script>

<style lang="scss" scoped>
    $light-blue: #D3EAFD;

    .message-mine {
        background-color:$light-blue;
        color:#1A1301;
    }
</style>
